const SERVER_STORAGE_KEY = 'icetana-server';
const SERVERS_AUTH_DATA_STORAGE_KEY = 'icetana-servers-data';
const LIVE_PREVIEW_DOMAIN = 'icetana.pages.dev';
const LIVE_PREVIEW_DEFAULT_SERVER = '10.2.3.244';

export { SERVER_STORAGE_KEY, LIVE_PREVIEW_DOMAIN, LIVE_PREVIEW_DEFAULT_SERVER, SERVERS_AUTH_DATA_STORAGE_KEY };
